goog.provide('el8.practicedata.immunizationRegistries');

goog.require('el8.service.urls');
goog.require('el8.practicedata.base');

el8.practicedata.immunizationRegistries = (function() {

  var historyIntegrationTypes = {
    none: 0,
    submission: 1,
    historyForecast: 2,
    submissionHistoryForecast: 3,
  };

  var _class = function(spec) { this.populate(spec); };
  _class.inheritsFrom(el8_Entity);

  _class.addStringProperty('code');
  _class.addStringProperty('description');
  _class.addStringProperty('integrationId');
  _class.addIntProperty('integrationType');
  _class.addBoolean('isActive');
  _class.addProperty('metadata');
  _class.addStringProperty('region');
  _class.addIntProperty('registryId');
  _class.addStringProperty('siteId');
  _class.addIntProperty('type');

  var that = new el8_EntitySet({
    model: function(spec) { return new _class(spec); },
    urlFn: function() {
      return el8.service.urls.get('getRegistryIntegrations', []);
    },
    urlLoad: function() { 
      return el8.service.urls.get('getRegistryIntegrations', []);
    },
  });

  /**
   * Returns a boolean value if any of the configured immunization registries
   * for the current practice are setup for checking history or forecasts
   */
  that.canCheckRegistryHistoryForecast = function () {
    var historyForecastIntegrationTypes = [
      historyIntegrationTypes.historyForecast, 
      historyIntegrationTypes.submissionHistoryForecast
    ];
    return that.all().some(function(registry){
      return historyForecastIntegrationTypes.includes(registry.getIntegrationType());
    });
  }

  return that;
})();